import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, BookOpenIcon, MapPinIcon, TrendingUpIcon, MessageSquareIcon, FileTextIcon } from 'lucide-react';
export function SolutionSection() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="w-full bg-[#F9F6F1] py-16 md:py-24 px-4" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        {/* Unique Mechanism */}
        <motion.div {...fadeInUp} className="mb-16" data-id="element-169">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] mb-6" data-id="element-170">
            El Método del <span className="text-[#D4A843]" data-id="element-171">Apilamiento</span>{' '}
            (Stacking Strategy)
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-172">
            En lugar de intentar ahorrar una fortuna, te enseñamos a combinar
            tres fuerzas legales:
          </p>

          <div className="flex flex-wrap gap-3 mb-6" data-id="element-173">
            <span className="inline-block bg-[#1B3A5C] text-white px-4 py-2 rounded-full text-sm font-semibold" data-id="element-174">
              Préstamo FHA (3.5%)
            </span>
            <span className="inline-block bg-[#1B3A5C] text-white px-4 py-2 rounded-full text-sm font-semibold" data-id="element-175">
              Programas DPA
            </span>
            <span className="inline-block bg-[#1B3A5C] text-white px-4 py-2 rounded-full text-sm font-semibold" data-id="element-176">
              Concesiones del Vendedor
            </span>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-177">
            Es la única forma legal de entrar a una casa con casi{' '}
            <span className="font-bold text-[#D4A843]" data-id="element-178">$0 de tu bolsillo</span>.
          </p>
        </motion.div>

        {/* What You Get */}
        <motion.div {...fadeInUp} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-179">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] mb-8" data-id="element-180">
            Lo Que Recibes
          </h2>

          <div className="space-y-6" data-id="element-181">
            <div className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-182">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-183">
                <BookOpenIcon className="w-5 h-5 text-green-600" data-id="element-184" />
              </div>
              <div data-id="element-185">
                <h3 className="font-bold text-[#1B3A5C] text-lg" data-id="element-186">
                  Guía Principal:
                </h3>
                <p className="text-gray-600" data-id="element-187">
                  El Plan 0-Down (Paso a paso de la A a la Z).
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-188">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-189">
                <MapPinIcon className="w-5 h-5 text-green-600" data-id="element-190" />
              </div>
              <div data-id="element-191">
                <h3 className="font-bold text-[#1B3A5C] text-lg" data-id="element-192">
                  Directorio DPA:
                </h3>
                <p className="text-gray-600" data-id="element-193">
                  Cómo localizar los fondos gratuitos disponibles en tu estado.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-194">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-195">
                <TrendingUpIcon className="w-5 h-5 text-green-600" data-id="element-196" />
              </div>
              <div data-id="element-197">
                <h3 className="font-bold text-[#1B3A5C] text-lg" data-id="element-198">
                  El Truco de los 30 Días:
                </h3>
                <p className="text-gray-600" data-id="element-199">
                  La estrategia exacta para subir tu puntaje de crédito rápido.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-200">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-201">
                <MessageSquareIcon className="w-5 h-5 text-green-600" data-id="element-202" />
              </div>
              <div data-id="element-203">
                <h3 className="font-bold text-[#1B3A5C] text-lg" data-id="element-204">
                  Script de Negociación:
                </h3>
                <p className="text-gray-600" data-id="element-205">
                  Qué decirle a tu agente para que el vendedor pague tus gastos
                  legales.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-206">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-207">
                <FileTextIcon className="w-5 h-5 text-green-600" data-id="element-208" />
              </div>
              <div data-id="element-209">
                <h3 className="font-bold text-[#1B3A5C] text-lg" data-id="element-210">
                  Lista de Documentos:
                </h3>
                <p className="text-gray-600" data-id="element-211">
                  Para que el banco no te ponga trabas y apruebe tu préstamo
                  rápido.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}